/**
 * Formata comprovante de fechamento de caixa para impressão térmica (80mm).
 */

const LINE_WIDTH = 53;
const SEPARATOR = '-'.repeat(LINE_WIDTH);
const SEPARATOR_LINE = '_'.repeat(LINE_WIDTH);

function center(text) {
  const value = String(text || '').trim();
  if (value.length >= LINE_WIDTH) return value.substring(0, LINE_WIDTH);
  const pad = Math.floor((LINE_WIDTH - value.length) / 2);
  return ' '.repeat(pad) + value;
}

function padLine(left, right) {
  const leftStr = String(left);
  const rightStr = String(right);
  const spaces = LINE_WIDTH - leftStr.length - rightStr.length;
  if (spaces < 1) {
    const maxLeft = LINE_WIDTH - rightStr.length - 1;
    return `${leftStr.substring(0, maxLeft)} ${rightStr}`;
  }
  return leftStr + ' '.repeat(spaces) + rightStr;
}

export function formatCurrencyBR(value) {
  const num = typeof value === 'number' ? value : parseFloat(value) || 0;
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(num);
}

function parseDateValue(value) {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function formatDateBR(value) {
  const date = parseDateValue(value);
  if (!date) return '--/--/----';
  return date.toLocaleDateString('pt-BR');
}

function formatTimeBR(value) {
  const date = parseDateValue(value);
  if (!date) return '--:--:--';
  return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}

/**
 * @param {Object} params
 * @param {string} params.operatorName
 * @param {number|string} params.cashRegisterId
 * @param {string} params.openingDate
 * @param {string} [params.closingDate]
 * @param {Array<{ description: string, amount: number }>} params.paymentLines
 * @param {number} params.totalSales
 * @param {number} params.totalItemsSold
 * @param {string} [params.companyName]
 */
export function buildCashRegisterClosingReceipt({
  operatorName,
  cashRegisterId,
  openingDate,
  closingDate,
  paymentLines = [],
  totalSales = 0,
  totalItemsSold = 0,
  companyName = 'Pró Médico Ltda'
}) {
  const lines = [];
  const totalAmount = paymentLines.reduce((sum, line) => sum + (parseFloat(line.amount) || 0), 0);

  lines.push(center('FECHAMENTO DE CAIXA'));
  lines.push(SEPARATOR);
  lines.push(`Operador: ${operatorName || 'Não informado'}`);
  lines.push(
    `Abertura de caixa: ${cashRegisterId} ${formatDateBR(openingDate)} ${formatTimeBR(openingDate)}`
  );
  lines.push(SEPARATOR);
  lines.push(center('RESUMO CAIXA'));
  lines.push(SEPARATOR);
  lines.push('');
  lines.push(padLine('Descrição', 'Valor R$'));
  lines.push(SEPARATOR_LINE);

  paymentLines.forEach((line) => {
    lines.push(padLine(line.description, formatCurrencyBR(line.amount)));
    lines.push(SEPARATOR);
  });

  lines.push(padLine('Total', formatCurrencyBR(totalAmount)));
  lines.push('');
  lines.push(SEPARATOR_LINE);
  lines.push(padLine('Total de Vendas', String(totalSales)));
  lines.push(padLine('Total de itens vendidos', String(Math.round(totalItemsSold))));
  lines.push('');
  lines.push(SEPARATOR);
  lines.push(
    padLine(
      `Emitido ${companyName}`,
      `${formatDateBR(closingDate)} ${formatTimeBR(closingDate)}`
    )
  );
  lines.push('');

  return lines.join('\n');
}

/**
 * @param {Object} params - Mesmos parâmetros de buildCashRegisterClosingReceipt
 */
export function printCashRegisterClosingReceipt(params) {
  const texto = buildCashRegisterClosingReceipt(params);
  return { texto };
}
